var _ = { escape: require('lodash.escape') };
module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<rm-icon class="icon--svg-spinners icon--svg-spinners--ring-resize"></rm-icon><span class="spinner_copy">Please wait while we fetch available time slots</span>';

}
return __p
};

/*
original source:

<rm-icon class="icon--svg-spinners icon--svg-spinners--ring-resize"></rm-icon>
<span class="spinner_copy">Please wait while we fetch available time slots</span>

*/
